import { render } from "./HeroTravelStatus.vue?vue&type=template&id=31fd7c48&scoped=true"
import script from "./HeroTravelStatus.vue?vue&type=script&lang=js"
export * from "./HeroTravelStatus.vue?vue&type=script&lang=js"

import "./HeroTravelStatus.vue?vue&type=style&index=0&id=31fd7c48&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fd7c48"]])

export default __exports__